import React, { ReactElement, useContext } from 'react'

import Fieldset from '../../Common/Components/Fieldset'
import Heading from '../../Common/Components/Heading'
import P from '../../Common/Components/P'
import FormRow from '../../Common/Components/FormRow'
import Checkbox from '../../Common/Components/Checkbox'

import { LanguageContext } from '../../Common/Contexts'

import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { TalkTime as TalkTimeLanguage } from '../../../../i18n'
import { HeadingLevel } from '../../Common/Components/Heading/Heading'

// CSS imports. Commented out because of current build process.
// import './TalkTime.scss'

/**
 * Component properties type.
 */
type Props = {
    excludeHeldTime: boolean
    setExcludeHeldTime: (checked: boolean) => void
}

/**
 * Talk time section of SLA/KPI tab.
 *
 * @param excludeHeldTime Report property.
 * @param setExcludeHeldTime Setter for corresponding report property.
 */
const TalkTime: React.FC<Props> = ({ excludeHeldTime, setExcludeHeldTime }: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle('TalkTime')

    return (
        <Fieldset className={'talk-time'}>
            <Heading level={HeadingLevel.ONE}>{language.get(TalkTimeLanguage.TalkTime_SectionHeader)}</Heading>
            <P>{language.get(TalkTimeLanguage.TalkTime_SectionPara)}</P>
            <FormRow isInline className={'exclude-held-time'}>
                <Checkbox
                    className='left-aligned-checkbox'
                    labelLeft={language.get(TalkTimeLanguage.ExcludeheldtimeLabel)}
                    onChange={setExcludeHeldTime}
                    isChecked={excludeHeldTime}
                />
            </FormRow>
        </Fieldset>
    )
}

export default React.memo(TalkTime)
